/**
 * Firebase Analytics Plugin
 *
 * Initializes Firebase Analytics on app startup.
 * For logging events, import and use the analytics composable or functions directly.
 *
 * References:
 * - https://capawesome.io/plugins/firebase/analytics/
 * - https://capacitorjs.com/docs/apis/device
 */

import { initializeAnalytics } from '@/core/analytics';

/**
 * Vue plugin for Firebase Analytics
 * Initializes analytics on app startup
 */
export const FirebaseAnalyticsPlugin = {
  async install(): Promise<void> {
    await initializeAnalytics();
  },
};
